import React from "react";

const Homesection3Card = (props) => {
  return (
    <div className="container -top-16 mt-24 w-full lg:w-96">
      <img className="w-full lg:w-full lg:h-[45vh] " src={props.image} alt="" />
      <div className="overlay opacity-40">
        <div className="text font-bold text-black">{props.title}</div>
      </div>
    </div>
  );
};

export default Homesection3Card;
// y img ka upper transition ki height kaise manage krenge konsi img ka size sahi krna hoga yaa y transiion ka images tumeh saari ek hi size ki leni hogi size diff ehta h kuch square kkuh rect isliye image size ssame lena ok